<template>
  <div
    class="column no-wrap"
    data-test-id="selected-permissions-list"
  >
    <div class="col-auto q-py-sm text-responsive-grey-9 text-subtitle2 row no-wrap items-center">
      <div class="col">
        {{ selectedPermissions.length }} selected {{ unsavedChangeCount ? `(${unsavedChangeCount} unsaved changes)` : '' }}
      </div>
      <div class="col-auto q-ml-auto">
        <q-btn
          class="q-mx-sm"
          label="Revert"
          flat
          dense
          :ripple="false"
          :disable="unsavedChangeCount === 0"
          @click="$emit('revert')"
        />
        <q-btn
          label="Clear"
          flat
          dense
          :ripple="false"
          :disable="!selectedPermissions.length"
          @click="$emit('clear')"
        />
      </div>
    </div>
    <div
      v-if="selectedPermissions.length"
      class="col overflow-auto"
    >
      <permissions-by-category-list
        :permissions="selectedPermissions"
        :selected-permission-actions="selectedPermissionActions"
        @click-permission="handlePermissionClick"
      />
    </div>
    <div
      v-else-if="!selectedPermissions.length"
      class="col column flex-center"
    >
      <div class="text-responsive-grey-6 text-subtitle1 text-center">
        Select permissions to preview
        <div class="text-italic">
          or
        </div>
      </div>
      <q-btn
        label="Preview No Permissions"
        color="primary"
        flat
        @click="$emit('preview-empty-permissions')"
      />
      <div class="q-mt-lg q-mb-xl text-responsive-grey-6 text-center">
        Note: Record Restrictions are not previewed
      </div>
    </div>
  </div>
</template>

<script>
import PermissionsByCategoryList from 'src/modules/admin/role/PermissionsByCategoryList'

export default {
  name: 'SelectedPermissionsList',
  components: {
    PermissionsByCategoryList
  },
  props: {
    selectedPermissionActions: {
      type: Array,
      required: true
    },
    unsavedChangeCount: {
      type: Number,
      required: true
    }
  },
  models: {
    permissions: {
      action: true,
      label: true,
      category: true,
      displayOrder: true
    }
  },
  emits: ['revert', 'clear', 'preview-empty-permissions', 'unselect-permission-actions'],
  computed: {
    selectedPermissions () {
      return _.filter(this.permissions.data, permission => _.includes(this.selectedPermissionActions, permission.action))
    }
  },
  methods: {
    handlePermissionClick (permission) {
      this.$emit('unselect-permission-actions', permission.action)
    }
  }
}
</script>
